import { AlkLogger } from '@alk/core';
import { injectable } from 'inversify';
import { ISpeedBumpService } from './speed-bump.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class SpeedBumpMock implements ISpeedBumpService {
    speedBumpStateObservable(): Observable<boolean> {
        AlkLogger.debug('SpeedBumpMock#speedBumpStateObservable');
        return NEVER;
    }
}
